import React, { ReactNode, ErrorInfo } from "react";

export interface TryCatchProps {
  try: () => ReactNode;
  catch: (error: ErrorData) => ReactNode;
}

export interface ErrorData {
  error: Error;
  errorInfo: ErrorInfo;
}

export interface TryCatchState {
  hasError: boolean;
  errorData: ErrorData | null;
}

export class TryCatch extends React.Component<TryCatchProps, TryCatchState> {
  constructor(props: TryCatchProps) {
    super(props);
    this.state = {
      hasError: false,
      errorData: null,
    };
  }

  static getDerivedStateFromError(_error: Error) {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const errorData: ErrorData = {
      error,
      errorInfo,
    };
    this.setState({ errorData });
  }

  render() {
    const { hasError, errorData } = this.state;
    const { try: tryComponent, catch: catchComponent } = this.props;

    if (hasError && errorData) {
      return catchComponent(errorData);
    }

    return tryComponent();
  }
}
